import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m4.797 8.8 2.9 2.7M4.797 8.8l2.9-2.8M5.797 8.8h8.6c2.7 0 4.8 2.1 4.8 4.6s-2.2 4.6-4.8 4.6"
    }, null, -1)
  ])))
}
export default { render: render }